"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionWrapperModal = void 0;
var styles_1 = require("@mui/material/styles");
var Modal_1 = __importDefault(require("shared/components/Modal/Modal"));
exports.TransactionWrapperModal = (0, styles_1.styled)(Modal_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        '& .MuiPaper-root': {
            borderRadius: 12,
            padding: theme.spacing(4, 6),
            paddingBottom: 0,
            margin: 'auto',
            maxWidth: 920,
            height: '85vh',
            overflowY: 'hidden',
        },
    });
});
